import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-03e760ac"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white",
  id: "sidenav-main"
};
var _hoisted_2 = {
  "class": "container-fluid"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "navbar-toggler-icon"
  }, null, -1);
});

var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "nav align-items-center d-md-none"
};
var _hoisted_6 = {
  "class": "navbar-collapse collapse show",
  id: "sidenav-collapse-main"
};
var _hoisted_7 = {
  "class": "navbar-collapse-header d-md-none"
};
var _hoisted_8 = {
  "class": "row"
};
var _hoisted_9 = {
  "class": "col-6 collapse-brand"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  "class": "col-6 collapse-close"
};
var _hoisted_12 = {
  "class": "navbar-nav"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("hr", {
    "class": "my-3"
  }, null, -1);
});

var _hoisted_14 = {
  "class": "navbar-heading text-muted"
};
var _hoisted_15 = {
  "class": "navbar-heading text-muted mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_navbar_toggle_button = _resolveComponent("navbar-toggle-button");

  var _component_router_link = _resolveComponent("router-link");

  var _component_user_login_view = _resolveComponent("user-login-view");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_navbar_toggle_button, {
    onClick: $options.showSidebar
  }, {
    "default": _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_router_link, {
    "class": "navbar-brand",
    to: "/"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("img", {
        src: $props.logo,
        "class": "navbar-brand-img",
        alt: "..."
      }, null, 8, _hoisted_4)];
    }),
    _: 1
  }), _renderSlot(_ctx.$slots, "mobile-right", {}, function () {
    return [_createElementVNode("ul", _hoisted_5, [_createVNode(_component_user_login_view)])];
  }, true), _renderSlot(_ctx.$slots, "default", {}, undefined, true), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_router_link, {
    to: "/"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("img", {
        src: $props.logo
      }, null, 8, _hoisted_10)];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_navbar_toggle_button, {
    onClick: $options.closeSidebar
  }, null, 8, ["onClick"])])])]), _createElementVNode("ul", _hoisted_12, [_renderSlot(_ctx.$slots, "links", {}, undefined, true)]), _hoisted_13, _createElementVNode("h6", _hoisted_14, _toDisplayString(_ctx.$t("label.language")), 1), _createVNode(_component_el_select, {
    modelValue: $data.languageValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.languageValue = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.languageOptions, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.$t("label.node")), 1), _createVNode(_component_el_select, {
    modelValue: $data.rpcValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.rpcValue = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.rpcOptions, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])], 512), [[_vShow, _ctx.$sidebar.showSidebar]])])]);
}